import { checkDiff } from '../../../utils/formValidation/errorCheckingFunctions';
import {
    getNumMaxMessage,
    getNumMoreThanMessage
} from '../../../utils/formValidation/errorMessageFunctions';

export const MIN_VALUE = 0;
export const MAX_VALUE = 999;

export const validate = (newEntry, contractConstants) => {
    let newErrors = {};

    if (newEntry.selfEmployedCoachPaymentRate) {
        if (newEntry.selfEmployedCoachPaymentRate <= MIN_VALUE) {
            newErrors = {
                ...newErrors,
                selfEmployedCoachPaymentRate: {
                    error: true,
                    message: getNumMoreThanMessage('Rate', '0')
                }
            };
        } else if (newEntry.selfEmployedCoachPaymentRate > MAX_VALUE) {
            newErrors = {
                ...newErrors,
                selfEmployedCoachPaymentRate: {
                    error: true,
                    message: getNumMaxMessage('Rate', MAX_VALUE)
                }
            };
        }
    }

    if (Object.keys(newErrors).length < 1) {
        newErrors = checkDiff(
            Number(newEntry.selfEmployedCoachPaymentRate),
            Number(contractConstants?.selfEmployedCoachPaymentRate)
        );
    }

    return newErrors;
};
